module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp3_8004.3de6272e.png";